import type { FC } from 'react';
import { useTranslation } from 'react-i18next';
import { ConfirmModal } from '@shared/ui/confirm-modal';

interface UnsavedChangesModalProps {
  isOpen: boolean;
  onLeave: () => void;
  onStay: () => void;
}

export const UnsavedChangesModal: FC<UnsavedChangesModalProps> = ({ isOpen, onLeave, onStay }) => {
  const { t } = useTranslation('translation', {
    keyPrefix: 'presets.editor.unsavedChanges',
  });

  return (
    <ConfirmModal
      isOpen={isOpen}
      title={t('title')}
      text={t('description')}
      confirmButtonLabel={t('leave')}
      cancelButtonLabel={t('stay')}
      confirmButtonDanger
      onConfirm={onLeave}
      onClose={onStay}
      onCancelButton={onStay}
      destroyOnClose
    />
  );
};
